import React from 'react';
import { File } from '@gravity-ui/icons';
import { Icon, Text } from '@gravity-ui/uikit';
import { block } from '../../../utils';
import './MonacoHeader.css';
const b = block('monaco-header');
export const MonacoHeader = ({ language, editButton }) => (React.createElement("div", { className: b() },
    React.createElement("div", null,
        React.createElement(Icon, { data: File, size: 18 }),
        React.createElement(Text, { variant: "body-3" }, language)), editButton !== null && editButton !== void 0 ? editButton : null));
